import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import {UninstallElement} from "../../../models/operations/UninstallElement";
import DisplayElement from "../DisplayElement";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    /**
     * Operation to display.
     */
    operation: UninstallElement;
}

/**
 * Displays the attributes specific to the uninstallation of an element.
 * @author Alizée Grand
 * @version 1.1
 * @creation 29/06/2022
 * @last_update 11/07/2022
 **/
class DisplayUninstallationElement extends React.Component<Props> {

    render() {

        /**
        * Retrieves from the props the function to access the translation.
        **/
        const getTranslation = this.props.t;

        return (

            <React.Fragment>
                <span><b>{getTranslation("display.operation.element-uninstallation.old-element")}</b> : </span>
                <br/>
                <DisplayElement element={this.props.operation.oldElement!}/>
                <br/>
            </React.Fragment>

        );

    };

}

export default withTranslation()(DisplayUninstallationElement);
